<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="operationTaskId !== null" :confirm="askConfirm"
                    :params="fromDashboard ? {} : {operationId: operationId}"
                    :route-back="fromDashboard ? 'Dashboard' : 'OperationShowTasks'" :title="form.name.value"/>
        <back-arrow v-else :confirm="askConfirm"
                    :params="fromDashboard ? {} : {operationId: operationId}"
                    :route-back="fromDashboard ? 'Dashboard' : 'OperationShowTasks'"
                    :title=" $t('New.e') + ' ' + $t('operationTask')"/>
      </div>
      <div class=" page-subtitle mt-2">{{ $t('OperationTask.subtitle') }}</div>

      <b-card class="col-md-12 my-3">
        <b-form v-unsave-detector @submit.stop.prevent="onSubmit">

          <div class="row">
            <div class="col-md-4"> 
              <b-form-group
                :invalid-feedback="form.name.invalidFeedback"
                :label="$t('OperationTask.name.label')"
                :state="form.name.state"
                class="medium-label mb-4"
                label-for="name-input">
                <b-form-input
                  id="name-input"
                  v-model="form.name.value"
                  :state="form.name.state"
                  maxlength="250"
                  required
                  type="text"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>

            <div v-if="operationId == null && operationTaskId == null" class="col-md-4">
              <b-form-group
                :invalid-feedback="form.operation.invalidFeedback"
                :label="$t('OperationTask.operation.label')"
                :state="form.operation.state"
                class="medium-label mb-4"
                label-for="operation-input">
                <b-form-select
                  id="operation-input"
                  v-model="form.operation.value"
                  :state="form.operation.state"
                  required
                  v-on:change="askConfirm=true;">
                  <option v-for="operation in operations" :value="operation.id">
                    {{ $t(operation.tostring) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.status.invalidFeedback"
                :label="$t('OperationTask.status.label')"
                :state="form.status.state"
                class="medium-label mb-4"
                label-for="statut-input">
                <b-form-select
                  id="statut-input"
                  v-model="form.status.value"
                  :state="form.status.state"
                  required
                  v-on:change="askConfirm=true;">
                  <option v-for="status in statusTask" :value="status.value">
                    {{ $t(status.text) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.date.invalidFeedback"
                :label="$t('OperationTask.deadlineDate.label')"
                :state="form.date.state"
                class="medium-label mb-4"
                label-for="date-input">
                <datepicker-input
                  id="date-input"
                  v-model="form.date.value"
                  :state="form.date.state"
                  :min="minDate"
                  @input="askConfirm=true;">
                </datepicker-input>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.alertType.invalidFeedback"
                :label="$t('OperationTask.alertType.label')"
                :state="form.alertType.state"
                class="medium-label mb-4"
                label-for="alertType-input">
                <b-form-select
                  id="alertType-input"
                  v-model="form.alertType.value"
                  :state="form.alertType.state"
                  required
                  v-on:change="askConfirm=true;">
                  <option v-for="alert in alertTypes" :value="alert.value">
                    {{ $t(alert.text) }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div class="col-md-4">
              <b-form-group
                :invalid-feedback="form.assignedTo.invalidFeedback"
                :label="$t('OperationTask.assignedTo.label')"
                :state="form.assignedTo.state"
                class="medium-label mb-4"
                label-for="assignedTo-input">
                <b-form-select
                  id="assignedTo-input"
                  v-model="form.assignedTo.value"
                  :state="form.assignedTo.state"
                  v-on:change="askConfirm=true;">
                  <option value="">{{ $t('OperationTask.assignedTo.none') }}</option>
                  <option v-for="user in collaborators" :value="user.id">
                    {{ user.firstName + ' ' + user.lastName }}
                  </option>
                </b-form-select>
              </b-form-group>
            </div>

            <div v-if="freeAlert" class="col-md-4">
              <b-form-group
                :invalid-feedback="form.freeAlert.invalidFeedback"
                :label="$t('OperationTask.alertType.free.label')"
                :state="form.freeAlert.state"
                class="medium-label mb-4"
                label-for="freeAlert-input">
                <b-form-input
                  id="freeAlert-input"
                  v-model="form.freeAlert.value"
                  v-disable-scroll
                  :placeholder="$t('alert.type.free.placeholder')"
                  :state="form.freeAlert.state"
                  required
                  step="1"
                  type="number"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-form-group
                :invalid-feedback="form.description.invalidFeedback"
                :label="$t('OperationTask.description.label')"
                :state="form.description.state"
                class="medium-label mb-4"
                label-for="description-input">
                <b-form-input
                  id="description-input"
                  v-model="form.description.value"
                  :state="form.description.state"
                  maxlength="250"
                  type="text"
                  v-on:change="askConfirm=true;">
                </b-form-input>
              </b-form-group>
            </div>
          </div>

          <div v-if="operationTaskId !== null" class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>

          <div v-else class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Create') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import backArrow from "../../components/b122/BackArrow";
import api from "../../services/api";
import DatepickerInput from '../../components/b122/editFields/DatepickerInput';

export default {
  name: "OperationTaskCreateEdit",

  components: {
    backArrow,
    DatepickerInput
  },

  data() {
    return {
      operationTaskId: this.$route.params.operationTaskId,
      operationId: this.$route.params.operationId,
      fromDashboard: this.$route.params.fromDashboard,
      operations: [],
      statusTask: [],
      alertTypes: [],
      collaborators: [],
      freeAlert: false,
      minDate: null,
      askConfirm: false,
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        operation: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        status:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        date:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        alertType:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        freeAlert:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        description:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        assignedTo:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  watch: {
    'form.alertType.value': function () {
      if (this.form.alertType.value === "FREE") {
        this.freeAlert = true
      } else {
        this.freeAlert = false
      }
    }
  },

  async mounted() {
    await this.fetchData()
    await this.setDate()
  },

  methods: {
    async setDate() {
      const now = new Date()
      this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    },

    async fetchData() {
      if (this.operationTaskId) {
        await this.fetchOperationTask()
      }
      if (!this.operationId && !this.operationTaskId) {
        await this.fetchAllOperations()
      }
      await this.getStatusTask()
      await this.getAlertTypes()
      await this.getCollaborators()
    },

    async fetchAllOperations() {
      api
        .get('/operation/getAllAuthorizedOperations')
        .then(response => {
          this.operations = response.data
        })
    },

    async fetchOperationTask() {
      await api
        .get(`/operationTask/${this.operationTaskId}`)
        .then(response => {
          this.form.name.value = response.data.name
          this.form.status.value = response.data.status.value
          this.form.description.value = response.data.description
          this.form.date.value = (response.data.date).split("/").reverse().join("-")
          this.form.alertType.value = response.data.alertType.value
          this.form.assignedTo.value = response.data.assignedTo ? response.data.assignedTo.id : ""
          this.operationId = response.data.operation.id
        })
    },

    async getStatusTask() {
      await api
        .get(`/operationTask/getStatusTask`)
        .then(response => {
          this.statusTask = response.data
        })
    },

    async getAlertTypes() {
      await api
        .get(`/operationTask/getAlertTypes`)
        .then(response => {
          this.alertTypes = response.data
        })
    },

    async getCollaborators() {
      await api
        .get(`/operationTask/getCollaborators`)
        .then(response => {
          this.collaborators = response.data
        })
    },

    async onSubmit() {
      if (this.form.date.value === null) {
        this.form.date.state = false
        this.form.date.invalidFeedback = this.$i18n.t('date.required')
        return
      }
      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('status', this.form.status.value)
      data.append('date', this.form.date.value)
      data.append('alertType', this.form.alertType.value)
      data.append('freeAlert', this.form.freeAlert.value)
      if (this.form.description.value) {
        data.append('description', this.form.description.value)
      }
      if (this.form.assignedTo.value && this.form.assignedTo.value !== "") {
        data.append('assignedToId', this.form.assignedTo.value)
      }
      if (this.operationId) {
        data.append('operationId', this.operationId)
      } else {
        data.append('operationId', this.form.operation.value)
      }

      let url = 'operationTask'
      if (this.operationTaskId) {
        url = '/operationTask/' + this.operationTaskId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.operationId = response.data.operation.id
          this.$router.push({
            name: this.fromDashboard ? 'Dashboard' : 'OperationShowTasks',
            params: this.fromDashboard ? {} : {
              operationId: this.operationId,
              currentSection: 3
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: this.fromDashboard ? 'Dashboard' : 'OperationShowTasks',
              params: {
                operationId: this.operationId,
                currentSection: 1,
                message: error.response.data.message
              }
            })
          }
        })
    },

    successToast(taskName) {
      this.$bvToast.toast(this.$i18n.t('OperationTask') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationTask/OperationTaskCreateEdit.vue